<div class="dashboard-home">
    <ng-scrollbar visibility="hover" [pointerEventsDisabled]="false">
        <div class="container-fluid h-100">
            <div class="row">
                <div class="col-sm-7 col-md-12 p-0">
                    <div class="container" *ngIf="isLoading">
                        <div class="row" *ngIf="!isMobile">
                            <div class="heading-skeleton-dashboard skeleton-placeholder ml-2"></div>
                            <div class="">
                                <div class="w-75 paragraph-line-skeleton skeleton-placeholder"></div>
                                <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                            </div>
                        </div>
                        <div class="row" *ngIf="isMobile">
                            <div class="heading-skeleton-dashboard skeleton-placeholder ml-2"></div>
                            <div class="">
                                <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                                <div class="w-75 paragraph-line-skeleton skeleton-placeholder"></div>
                            </div>
                            <div class="">
                                <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                                <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                                <div class="w-25 paragraph-line-skeleton skeleton-placeholder"></div>
                            </div>
                        </div>
                    </div>
                    <div class="container" *ngIf="!isLoading">
                        <div class="row p-0">
                            <div class="col-sm-12 dashboard-intro-head">Gyan AI Research Assistant</div>
                            <div class="col-sm-12 dashboard-intro-sub">
                                <div>Discover, explore, and learn using Gyan’s auto-curating, self-organizing Research Assistant.</div>
                                <div>Discover new insights. Use Gyan knowledge maps to visually navigate through content. Keep your research results continuously updated.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-7 offset-sm-2 carousel-content" *ngIf="isLoading && isMobile">
                    <div class="carousel-header-font carousel-header-font-skeleton skeleton-placeholder"></div>
                    <div class="mx-auto skeleton-circle"></div>
                    <div class="mx-auto col-sm-9 text-center">
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-50 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="bullet-skeleton w-25 paragraph-line-skeleton skeleton-placeholder"></div>
                    </div>
                </div>
                <div class="col-sm-7 d-md-none offset-sm-2 carousel-content" *ngIf="!isLoading && isMobile">
                    <owl-carousel-o [options]="customOptions">
                        <ng-container *ngFor="let item of carouselData">
                            <ng-template carouselSlide>
                                <div class="carousel-header-font">{{ item.title }}</div>
                                <div class="">
                                    <img class="img-fluid mx-auto carousel-image" [src]="item.image" />
                                </div>
                                <div class="mx-auto col-sm-9 text-center mt-15">
                                    {{ item.content }}
                                </div>
                            </ng-template>
                        </ng-container>
                    </owl-carousel-o>
                </div>
                <div class="col-md-12 d-sm-none d-md-block pt-5" style="text-align: -webkit-center" *ngIf="!isLoading && !isMobile">
                    <owl-carousel-o [options]="customOptions_desktop">
                        <ng-container *ngFor="let item of carouselData">
                            <ng-template carouselSlide>
                                <div class="carousel-header-font">{{ item.title }}</div>
                                <div class="">
                                    <img class="img-fluid mx-auto carousel-image" [src]="item.image" />
                                </div>
                                <div class="mx-auto col-sm-9 text-center mt-15">
                                    {{ item.content }}
                                </div>
                            </ng-template>
                        </ng-container>
                    </owl-carousel-o>
                </div>
            </div>
            <div *ngIf="isLoading && !isMobile" class="flex-container mt-4">
                <div>
                    <div class="carousel-header-font carousel-header-font-skeleton-desktop skeleton-placeholder"></div>
                    <div class="skeleton-circle carousel-image-desktop"></div>
                    <div class="carousel-body-desktop">
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-75 paragraph-line-skeleton skeleton-placeholder"></div>
                    </div>
                </div>
                <div>
                    <div class="carousel-header-font carousel-header-font-skeleton-desktop skeleton-placeholder"></div>
                    <div class="skeleton-circle carousel-image-desktop"></div>
                    <div class="carousel-body-desktop">
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-75 paragraph-line-skeleton skeleton-placeholder"></div>
                    </div>
                </div>
                <div>
                    <div class="carousel-header-font carousel-header-font-skeleton-desktop skeleton-placeholder"></div>
                    <div class="skeleton-circle carousel-image-desktop"></div>
                    <div class="carousel-body-desktop">
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
                        <div class="w-75 paragraph-line-skeleton skeleton-placeholder"></div>
                    </div>
                </div>
            </div>
        </div>
    </ng-scrollbar>
</div>
